import _styled from "styled-components";
import React from "react";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { hasItems, takeFirst } from "~/features/app/utils";
import { useLinkIcon } from "~/features/ui/link/use-link-icon";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
const fragment = graphql(`
  fragment ProductHeroLinks on productHeroLinks_productHeroLink_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
type Props = FragmentType<typeof fragment> & {
  links?: FragmentType<typeof fragment>[];
};
export function ProductHeroLink(props: FragmentType<typeof fragment>) {
  const {
    link
  } = useFragment(fragment, props);
  const cta = takeFirst(link);
  const icon = useLinkIcon(cta);
  if (!isLinkValid(cta)) {
    return null;
  }
  return <Button as={Link} {...cta} variant="secondary" icon={icon} />;
}
export function ProductHeroLinks(props: Props) {
  const {
    links
  } = props;
  if (!hasItems(links)) {
    return null;
  }
  return <_StyledUl>
      {links?.map((link, index) => <li key={index}>
          <ProductHeroLink {...link} />
        </li>)}
    </_StyledUl>;
}
var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "product-hero-links___StyledUl",
  componentId: "sc-apzavo-0"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.8rem"
});